import { FormItem } from '../../../components/Form/FormItem';
import Link from '../../../components/Link';
import { VALIDATORS } from '../../../services/Validation';
import UserImportConfig from '../UserImport/Configuration';
import { VALIDATION_ERROR } from './constants';

export default function WorkableConfig(props) {
    return (
        <UserImportConfig {...props} name="Workable" validationErrorMessage={VALIDATION_ERROR}>
            <GeneralSection />
        </UserImportConfig>
    );
}

function GeneralSection() {
    return (
        <div>
            <h5>General</h5>
            <section>
                <div className="admin-config-flex-container">
                    <div>
                        <FormItem
                            name="systemSpecificProperties.workableSubdomain"
                            label="Subdomain"
                            validators={[VALIDATORS.required(), VALIDATORS.urlDomain()]}
                        />
                    </div>
                    <div>
                        <FormItem
                            name="systemSpecificProperties.workablePartnerToken"
                            label="Partner Token"
                            validators={[VALIDATORS.required()]}
                        />
                    </div>
                </div>
                <aside>
                    You can find the subdomain associated with your Workable account by visiting the{' '}
                    <Link openInNewTab href="https://workable.com/backend/settings/company_profile">
                        company profile settings
                    </Link>{' '}
                    in your Workable account and the partner token you generate by finding the Small Improvements
                    integration under{' '}
                    <Link openInNewTab href="https://workable.com/backend/settings/integrations">
                        the integrations settings
                    </Link>
                    .
                </aside>
            </section>
        </div>
    );
}
